import { render, staticRenderFns } from "./BaseButtonPrimarySmall.vue?vue&type=template&id=2ddcd4e2&"
import script from "./BaseButtonPrimarySmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonPrimarySmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports